import React from "react";
import { InfoCircleIcon } from "../../atoms/InfoCircleIcon";
import { KgCollapsedNodeHover } from "../KgCollapsedNodeHover";
import { KgOntologyOrbitIcon } from "../../atoms/KgOntologyOrbitIcon";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  Circle,
  Content,
  IconBox,
  Label,
  LabelRow,
  Name,
  TextStack,
} from "./KgOntologyNodeCard.styles";
import type { KgOntologyNodeCardProps } from "./KgOntologyNodeCard.types";

export const KgOntologyNodeCard: React.FC<KgOntologyNodeCardProps> = ({
  name,
  hasWarning = false,
  collapsed = false,
  visualState = "default",
  isSelected = false,
  onClick,
}) => {
  if (collapsed) {
    return (
      <KgCollapsedNodeHover
        icon={<KgOntologyOrbitIcon size={16} />}
        color={rawColors.accent.ontologyGreen}
        bgColor={rawColors.accent.ontologyGreenBg}
        visualState={visualState}
        title={name}
        subtitle="Ontology"
      />
    );
  }

  return (
    <Circle $visualState={visualState} $isSelected={isSelected} onClick={onClick} role="group" tabIndex={0}>
      <Content>
        <IconBox>
          <KgOntologyOrbitIcon size={16} />
        </IconBox>
        <TextStack>
          <LabelRow>
            <Label>Ontology</Label>
            {hasWarning && (
              <InfoCircleIcon size={12} color={rawColors.accent.warningYellow} />
            )}
          </LabelRow>
          <Name title={name}>{name}</Name>
        </TextStack>
      </Content>
    </Circle>
  );
};

export default KgOntologyNodeCard;
